export const esquemaCampos = {
   user: {
      valor:
         process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DS_ENV !== 'PROD'
            ? 'dev@dscont.pe'
            : '',
      error: ''
   },
   pass: {
      valor:
         process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DS_ENV !== 'PROD'
            ? '123'
            : '',
      error: ''
   }
};

export const esquemaValidacion = {
   user: {
      requerido: true,
      validador: {
         regla: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
         error: 'El correo electronico no tiene un formato valido: [nombre]@[dominio].[etc]'
      }
   },
   pass: {
      requerido: true
   }
};
